import { PageTitle } from '@/shared/ui/text/page-title';
import { SettingsColumn } from '@/widgets/settings/settings-column';

import { SuperbillSection } from './billing-documents-page/superbill-section';

export function BillingDocumentsPage() {
    return (
        <SettingsColumn className="space-y-8">
            <PageTitle>Billing Documents</PageTitle>
            <SuperbillSection />
        </SettingsColumn>
    );
}
